module.exports = __webpack_public_path__ + "static/media/morrison-utility-services-logo.e0128aee.svg";